"use client";
import React from "react";
import {
  Box,
  Center,
  Divider,
  Heading,
  TableContainer,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  VStack,
  HStack,
  Flex,
  SimpleGrid,
  Stack,
} from "@chakra-ui/react";
import {useSectionHeadingVariant} from "@/theme/components/useSectionHeading";
import PricingFooter from "@/components/pricingFooter";
import {VMWARE_CONSTANTS, FOOTER_CONSTANTS} from "./constants";

export const VmwareDesktopView = () => {
  return (
    <TableContainer>
      <Table
        variant="striped"
        border={"2px solid rgb(237,242,247)"}
        width={"100%"}
        sx={{
          th: {textAlign: "center"},
          td: {textAlign: "center"},
        }}
      >
        <Thead>
          <Tr>
            <Th>Number of Hosts</Th>
            <Th>RAM</Th>
            <Th>CPU / host</Th>
            <Th>Storage</Th>
            <Th>Price/Month</Th>
          </Tr>
        </Thead>
        <Tbody>
          {VMWARE_CONSTANTS.data.map((plan, index) => (
            <Tr key={index} fontSize={"16px"}>
              <Td>{plan.numberOfHosts}</Td>
              <Td>{plan.ram}</Td>
              <Td>{plan.cpu}</Td>
              <Td>{plan.storage}</Td>
              <Td>
                <Text fontWeight={"700"} fontSize={"18px"} color="blue.600">
                  {plan.pricePerMonth}
                </Text>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export const VmwareMobileView = () => {
  return (
    <SimpleGrid columns={{base: 1, sm: 2}} spacing={6}>
      {VMWARE_CONSTANTS.data.map((plan, index) => (
        <VStack
          key={index}
          borderRadius="lg"
          borderWidth="1px"
          borderColor="gray.200"
          boxShadow="md"
          spacing={4}
          w="100%"
          p={4}
          bg="white"
        >
          <HStack spacing={3} align="center" w="full">
            <Flex flex="1" direction="column">
              <Text fontWeight="bold" fontSize="lg">
                {plan.cpu} (CPU/host)
              </Text>
            </Flex>
          </HStack>

          <Divider borderColor="gray.200" />

          <Stack direction="row" spacing={4} justify="space-between" w="full">
            <Flex direction="column">
              <Text fontSize="sm" color="gray.600">
                Hosts
              </Text>
              <Text fontWeight="medium" fontSize="md">
                {plan.numberOfHosts}
              </Text>
            </Flex>
            <Flex direction="column">
              <Text fontSize="sm" color="gray.600">
                RAM
              </Text>
              <Text fontWeight="medium" fontSize="md">
                {plan.ram}
              </Text>
            </Flex>
          </Stack>

          <Stack direction="row" spacing={4} justify="space-between" w="full">
            <Flex direction="column">
              <Text fontSize="sm" color="gray.600">
                Storage
              </Text>
              <Text fontWeight="medium" fontSize="md">
                {plan.storage}
              </Text>
            </Flex>
            <Flex direction="column">
              <Text fontSize="sm" color="gray.600">
                Price
              </Text>
              <Text fontWeight="bold" fontSize="lg" color="blue.600">
                {plan.pricePerMonth}
              </Text>
            </Flex>
          </Stack>
        </VStack>
      ))}
    </SimpleGrid>
  );
};

const VmwareCloudTable = () => {
  const HeadingVariant = useSectionHeadingVariant();
  return (
    <Box id="vmware">
      <Heading variant={HeadingVariant} textAlign={"center"} mb={8}>
        {VMWARE_CONSTANTS.title}
      </Heading>
      <Center display={{md: "none"}} w="full">
        <VmwareMobileView />
      </Center>
      <Box display={{base: "none", md: "block"}}>
        <VmwareDesktopView />
      </Box>
      <PricingFooter {...FOOTER_CONSTANTS} />
      <Divider borderWidth="2px" borderColor="#ECECEC" my={10} />
    </Box>
  );
};

export default VmwareCloudTable;
